import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './Ratings.css';

interface IRatingsProps {
  title: React.ReactNode;
  ratings: React.ReactNode;
}

export function Ratings({ title, ratings }: IRatingsProps) {
  return (
    <section id="ratings" className={styles['ratings']}>
      <Layout>
        <div className={styles['ratings__title']}>{title}</div>

        <ul className={styles['ratings__list']}>
          {React.Children.map(ratings, (rating, index) => (
            <li key={index} className={styles['ratings__list-item']}>
              {rating}
            </li>
          ))}
        </ul>
      </Layout>
    </section>
  );
}
